/**
 * Get the reporting start date from the application.
 */

import { createSelector } from 'reselect';

import getApplicationSelector from '/business/shared/state/selectors/application/getApplicationSelector';

export default createSelector([getApplicationSelector], (application = null) => application?.reportingStartDate);
